export const WEBHOOK_INITIAL_DATA = {
  url: null,
  description: "",
  events: "order.completed",
  active: true,
};
